import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::submit
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:22
* @route '/{locale}/tools/image/bulk-compress'
*/
export const submit = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

submit.definition = {
    methods: ["post"],
    url: '/{locale}/tools/image/bulk-compress',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::submit
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:22
* @route '/{locale}/tools/image/bulk-compress'
*/
submit.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return submit.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::submit
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:22
* @route '/{locale}/tools/image/bulk-compress'
*/
submit.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::submit
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:22
* @route '/{locale}/tools/image/bulk-compress'
*/
const submitForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::submit
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:22
* @route '/{locale}/tools/image/bulk-compress'
*/
submitForm.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

submit.form = submitForm

const bulkCompress = {
    submit: Object.assign(submit, submit),
}

export default bulkCompress